var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CModal',{attrs:{"show":_vm.boo_modal,"close-on-backdrop":false,"centered":true,"title":_vm.title,"size":'lg',"btn_cancel":true,"btn_ok":true,"booTitile":true},on:{"mtdclosemodal":_vm.mtdclosemodal}},[_c('div',{staticClass:"row mx-0 px-2"},[(
        (_vm.destination === '' || _vm.destination === 'ALTA') &&
        [1, 3, 7].includes(Number(_vm.type_history))
      )?_c('div',{staticClass:"col-xl-4 text-center btn-home my-2"},[_c('button',{staticClass:"btn w-100 fw-bold",attrs:{"type":"button"},on:{"click":function($event){return _vm.mtdstoredata(0, 'ALTA')}}},[_vm._v(" ALTA ")])]):_vm._e(),(
        _vm.subsubcategorie_id != 2 &&
        _vm.type_history != 6 &&
        _vm.type_history != 1 &&
        (_vm.destination === '' || _vm.destination === 'FUGA')
      )?_c('div',{staticClass:"col-xl-4 text-center btn-home my-2"},[_c('button',{staticClass:"btn w-100 fw-bold",attrs:{"type":"button"},on:{"click":function($event){return _vm.mtdstoredata(0, 'FUGA')}}},[_vm._v(" FUGA ")])]):_vm._e(),(
        _vm.subsubcategorie_id != 2 &&
        _vm.type_history != 6 &&
        _vm.type_history != 1 &&
        (_vm.destination === '' || _vm.destination === 'FALLECIMIENTO')
      )?_c('div',{staticClass:"col-xl-4 text-center btn-home my-2"},[_c('button',{staticClass:"btn w-100 fw-bold",attrs:{"type":"button"},on:{"click":function($event){return _vm.mtdstoredata(0, 'FALLECIMIENTO')}}},[_vm._v(" FALLECIMIENTO ")])]):_vm._e(),(
        _vm.type_history != 3 &&
        _vm.type_history != 6 &&
        _vm.type_history != 4 &&
        _vm.type_history != 1 &&
        _vm.type_history != 7 &&
        _vm.subsubcategorie_id != 2 &&
        _vm.rolname == 'DOCTOR(A)'
      )?_c('div',{staticClass:"col-xl-4 text-center btn-home my-2"},[_c('button',{staticClass:"btn w-100 fw-bold",attrs:{"type":"button"},on:{"click":function($event){return _vm.mtdstoredata()}}},[_vm._v(" CONSULTA ")])]):_vm._e(),(
        _vm.type_history == 1 &&
        _vm.type_history != 6 &&
        _vm.subsubcategorie_id != 2 &&
        _vm.rolname == 'DOCTOR(A)'
      )?_c('div',{staticClass:"col-xl-4 text-center btn-home my-2"},[_c('button',{staticClass:"btn w-100 fw-bold",attrs:{"type":"button"},on:{"click":function($event){return _vm.mtdstoredata(4, 'LECTURA DE RESULTADOS')}}},[_vm._v(" LECTURA DE RESULTADOS ")])]):_vm._e(),(
        _vm.type_history != 7 &&
        _vm.type_history != 6 &&
        _vm.type_history != 3 &&
        _vm.type_history != 4 &&
        _vm.type_history != 1 &&
        _vm.subsubcategorie_id != 2 &&
        _vm.rolname == 'DOCTOR(A)'
      )?_c('div',{staticClass:"col-xl-4 text-center btn-home my-2"},[_c('button',{staticClass:"btn w-100 fw-bold",attrs:{"type":"button"},on:{"click":function($event){return _vm.mtdstoredata(3, 'EMERGENCIA')}}},[_vm._v(" EMERGENCIA ")])]):_vm._e(),(
        _vm.type_history != 3 &&
        _vm.type_history != 1 &&
        _vm.subsubcategorie_id != 2 &&
        _vm.rolname == 'DOCTOR(A)'
      )?_c('div',{staticClass:"col-xl-4 text-center btn-home my-2"},[_c('button',{staticClass:"btn w-100 fw-bold",attrs:{"type":"button"},on:{"click":function($event){return _vm.mtdstoredata(1, 'HOSPITALIZACION')}}},[_vm._v(" HOSPITALIZACION ")])]):_vm._e(),(
        _vm.type_history != 4 &&
        _vm.subsubcategorie_id != 2 &&
        _vm.type_history != 1 &&
        _vm.rolname == 'DOCTOR(A)'
      )?_c('div',{staticClass:"col-xl-4 text-center btn-home my-2"},[_c('button',{staticClass:"btn w-100 fw-bold",attrs:{"type":"button"},on:{"click":function($event){return _vm.mtdstoredata(2, 'UCI')}}},[_vm._v(" UCI ")])]):_vm._e(),(
        _vm.subsubcategorie_id != 2 &&
        _vm.type_history != 6 &&
        _vm.type_history != 1 &&
        (_vm.destination === '' || _vm.destination === 'RETIRO VOLUNTARIO')
      )?_c('div',{staticClass:"col-xl-4 text-center btn-home my-2"},[_c('button',{staticClass:"btn w-100 fw-bold",attrs:{"type":"button"},on:{"click":function($event){return _vm.mtdstoredata(0, 'RETIRO VOLUNTARIO')}}},[_vm._v(" RETIRO VOLUNTARIO ")])]):_vm._e(),(
        _vm.type_history != 6 &&
        _vm.subsubcategorie_id != 2 &&
        _vm.type_history != 1 &&
        _vm.rolname == 'DOCTOR(A)'
      )?_c('div',{staticClass:"col-xl-4 text-center btn-home my-2"},[_c('button',{staticClass:"btn w-100 fw-bold",attrs:{"type":"button"},on:{"click":function($event){return _vm.mtdstoredata(6, 'SOP')}}},[_vm._v(" SOP ")])]):_vm._e(),(
        (_vm.destination === '' || _vm.destination === 'URPA') && _vm.type_history == 6
      )?_c('div',{staticClass:"col-xl-4 text-center btn-home my-2"},[_c('button',{staticClass:"btn w-100 fw-bold",attrs:{"type":"button"},on:{"click":function($event){return _vm.mtdstoredata(0, 'URPA')}}},[_vm._v(" URPA ")])]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }